import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';

const VendorReferralRoute = () => {
  const { referralEnabled, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!referralEnabled) {
    return <Navigate to="/vendor/dashboard" replace />;
  }

  return <Outlet />;
};

export default VendorReferralRoute;